const GPS_MENSAGEM_PATTERN = /^88-(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)/;
const GPS_COORDS_ONLY_PATTERN = /^(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?);?$/;
const CAMEL_CASE_SPLIT_PATTERN = /([a-záàâãéêíóôõúç])([A-ZÁÀÂÃÉÊÍÓÔÕÚÇ])/g;

const COR_LAMPADA_ABREV = {
  Amr: 'Amarelo',
  Ama: 'Amarelo',
  Vrm: 'Vermelho',
  Vrd: 'Verde',
  Ver: 'Verde',
};

export const GPS_DIVERGENCIA_TEXTO = 'Posição diferente da salva no sistema';

export function formatMensagemErroExibicao(mensagem) {
  if (!mensagem) return mensagem;

  const raw = String(mensagem).trim();
  const gpsMatch = raw.match(GPS_MENSAGEM_PATTERN);

  if (gpsMatch) {
    return `${GPS_DIVERGENCIA_TEXTO}: ${gpsMatch[1]}, ${gpsMatch[2]}`;
  }

  const coordsOnlyMatch = raw.match(GPS_COORDS_ONLY_PATTERN);
  if (coordsOnlyMatch) {
    return `${GPS_DIVERGENCIA_TEXTO}: ${coordsOnlyMatch[1]}, ${coordsOnlyMatch[2]}`;
  }

  return raw;
}

function separarCamelCase(texto) {
  return String(texto || '').replace(CAMEL_CASE_SPLIT_PATTERN, '$1 $2');
}

export function normalizarTextoBusca(texto) {
  return separarCamelCase(String(texto || ''))
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s\u00a0\r\n\t]+/g, ' ')
    .trim();
}

export function mensagemAtendeBusca(mensagemExibicao, termoBusca) {
  const termo = normalizarTextoBusca(termoBusca);
  if (!termo) return true;

  const mensagem = normalizarTextoBusca(mensagemExibicao);
  const mensagemCompacta = mensagem.replace(/\s+/g, '');
  const termoCompacto = termo.replace(/\s+/g, '');

  return mensagem.includes(termo) || mensagemCompacta.includes(termoCompacto);
}

function expandirCorLampada(texto) {
  return String(texto || '').replace(/;\s*([A-Za-z]{2,4})\s*;?\s*$/i, (match, abrev) => {
    const cor = COR_LAMPADA_ABREV[abrev] || abrev;
    return ` (${cor})`;
  });
}

export function humanizarMensagemErro(mensagem) {
  if (!mensagem || typeof mensagem !== 'string') {
    return mensagem;
  }

  const formatada = formatMensagemErroExibicao(mensagem);
  if (formatada !== mensagem) {
    return formatada;
  }

  const semCodigo = mensagem.replace(/^\d+-/, '').replace(/;$/, '').trim();
  return separarCamelCase(expandirCorLampada(semCodigo));
}
